// Reference https://github.com/SpotIM/spotim-integration-docs/blob/master/api/single-sign-on/spa.js#L43C3-L51C4
import type { SPOTIM } from 'types/global/spotim';

export function watchForSpotimObject(): Promise<SPOTIM> {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (typeof window.SPOTIM !== 'object') return;

      resolve(window.SPOTIM);
      clearInterval(interval);
    }, 10);
  });
}
